export default __webpack_public_path__ + "static/media/chevron-arrow-down.1b7d4720.svg";